import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs';
import { Observable, Subject, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';

import { Espectaculo } from '../models/espectaculo';
@Injectable({
  providedIn: 'root'
})
export class EspectaculoService {

  constructor(private http: HttpClient) { }

  private espectaculos: Espectaculo[];
  private espectaculos$ = new Subject<Espectaculo[]>();

  private espectaculo: Espectaculo;
  private espectaculo$ = new Subject<Espectaculo>();

  change(val) {
    this.espectaculos = val;
    this.espectaculos$.next(this.espectaculos);
  }
  get$(): Observable<Espectaculo[]> {
    return this.espectaculos$.asObservable();
  }

  changeOne(val) {
    this.espectaculo = val;
    this.espectaculo$.next(this.espectaculo);
  }
  getOne$(): Observable<Espectaculo> {
    return this.espectaculo$.asObservable();
  }

  getAll(): Observable<Espectaculo[]> {
    return this.http.get(environment.apiUrl + 'espectaculo')
      .pipe(map((res: any) => {
        return res;
      }));
  }

  getFilter(data): Observable<Espectaculo[]> {

    return this.http.post(environment.apiUrl + 'espectaculo/getFilter', data)
      .pipe(map((res: any) => {
        return res;
      }));
  }

  get(id) {
    return this.http.get(environment.apiUrl + 'espectaculo/' + id)
      .pipe(map((res: any) => {
        return res;
      }));
  }
  add(data) {
    return this.http.post(environment.apiUrl + 'espectaculo', data)
      .pipe(
        map((res: any) => { return res; }),
        catchError(e => throwError(e))
      );
  }
  edit(data) {
    const apiUrl = environment.apiUrl + 'espectaculo';
    const url = `${apiUrl}/${data["id"]}`;


    return this.http.put(url, data)
      .pipe(
        map((res: any) => { return res; }),
        catchError(e => throwError(e))
      );
  }

  delete(id) {

    return this.http.delete(environment.apiUrl + 'espectaculo/' + id)
      .pipe(
        map((res: any) => { return res; }),
        catchError(e => throwError(e))
      );
  }

  changeImageHorizontal(formData: FormData, id): Observable<object> {
    return this.http.post(environment.apiUrl + 'espectaculo/changeImgHorizontal/' + id, formData)
      .pipe(
        map((res: any) => { return res.data; }),
        catchError(e => throwError(e))
      );
  }

  changeImageVertical(formData: FormData, id): Observable<object> {
    return this.http.post(environment.apiUrl + 'espectaculo/changeImgVertical/' + id, formData)
      .pipe(
        map((res: any) => { return res.data; }),
        catchError(e => throwError(e))
      );
  }

  deleteImg(id) {
    return this.http.delete(environment.apiUrl + 'espectaculo/deleteImg/' + id)
      .pipe(
        map((res: any) => { return res; }),
        catchError(e => throwError(e))
      );
  }

  destacado(data, id) {
    return this.http.post(environment.apiUrl + 'espectaculo/updateDestacado/' + id, data)
      .pipe(
        map((res: any) => { return res; }),
        catchError(e => throwError(e))
      );
  }

}
